import { useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Send } from "lucide-react";

export function ReportThread({ report, onPosted }) {
  const { user } = useAuth();
  const [text, setText] = useState("");
  const [busy, setBusy] = useState(false);
  const msgs = report.messages || [];

  const send = async () => {
    if (!text.trim()) return;
    setBusy(true);
    try {
      await api.post(`/advisor/reports/${report.id}/messages`, { content: text.trim() });
      setText("");
      onPosted?.();
    } catch (e) { toast.error(formatApiError(e?.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <div className="mt-3 rounded-lg bg-slate-50 p-3">
      <div className="space-y-2">
        {msgs.length === 0 && <p className="text-xs text-slate-400">No replies yet — start the conversation.</p>}
        {msgs.map((m, i) => {
          const mine = m.sender_role === user?.role;
          return (
            <div key={i} className={`flex ${mine ? "justify-end" : "justify-start"}`} data-testid="report-message">
              <div className={`max-w-[80%] rounded-2xl px-3 py-1.5 text-sm ${mine ? "bg-[#003057] text-white" : "border border-slate-200 bg-white text-slate-700"}`}>
                <p className="text-[10px] font-bold uppercase tracking-wide opacity-70">{m.sender_name}</p>
                <p className="whitespace-pre-line">{m.content}</p>
              </div>
            </div>
          );
        })}
      </div>
      <div className="mt-2 flex gap-2">
        <Input data-testid="report-reply-input" value={text} onChange={(e) => setText(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && send()} placeholder="Write a reply…" className="flex-1 bg-white" />
        <Button data-testid="report-reply-send" onClick={send} disabled={busy} size="sm"
          className="rounded-full bg-[#78be21] font-bold text-[#00243f] hover:bg-[#6aac1c]"><Send className="h-4 w-4" /></Button>
      </div>
    </div>
  );
}
